var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.valid),expression:"valid"}],staticClass:"messages-body"},[_c('Head',{attrs:{"connection":_vm.connection,"person":_vm.person}}),_c('Body',{attrs:{"messages":_vm.messages,"identity":_vm.identity}}),_c('Controls',{on:{"send":_vm.sendMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }